export default __webpack_public_path__ + "static/media/DragonCh4.20975cdb.svg";